<template>
  <!-- 商店 -->
  <div id="app3" >
    <Card :class="{ 'blackBackGroup': isActive, 'blackBackGroup2': !isActive }" style="font-family: Arial,Helvetica,Sans-Serif;">
      <p slot="title">商店</p>
      <div slot="extra"></div>
      <div>
        <div class="knapsack" style="margin-top: 40px">
          <Poptip
            trigger="hover"
            v-for="item in shopList"
            :key="item.marketName"
            :title="item.marketName.toString()"
          >
            <p
              style="white-space: nowrap; height: 24px"
              :style="{ color: distinguishColor(item.color) }"
            >
              <Tag size="medium"  style="margin: 10px 0" v-if="!isActive"> {{ item.marketName }} * {{ item.marketNum }}</Tag>
              <span  style="color: #37b4c8e0" v-if="isActive"> 『 {{ item.marketName }}』 * {{ item.marketNum }}</span>
              <!--            <span class="jjt_smail">{{ item.marketNum }}</span>-->
              <!--            <Tag type="dot" closable color="error"></Tag>-->
              <Button
                @click.prevent="purchaseItem(item)"
                size="small"
                type="info" ghost
              >购买
              </Button>
              <Button
                @click.prevent="purchaseItem1(item)"
                size="small"
                type="info"
              >
                批量购买
              </Button>
            </p>
            <div slot="content" >
              <p v-if="item.marketPrice">
                商品价格 {{ item.marketPrice }}
                {{ item.priceType == 0 ? "金币" : "灵石" }}
              </p>
              <p v-if="item.marketNum">购买次数 {{ item.marketNum }}</p>
              <p v-if="item.marketLevel">
                商品最低购买等级 {{ item.marketLevel }}
              </p>
              <p v-if="item.typeDec">装备类型 {{ item.typeDec }}</p>
              <p v-if="item.level">装备等级 {{ item.level }}</p>
              <p v-if="item.itemNum">物品数量： {{ item.itemNum }}</p>
              <p v-if="item.life">生命值 {{ item.life }}</p>
              <p v-if="item.mana">真气值 {{ item.mana }}</p>
              <p v-if="item.attack">攻击力 {{ item.attack }}</p>
              <p v-if="item.magAttack">法术攻击力 {{ item.magAttack }}</p>
              <p v-if="item.defense">防御力 {{ item.defense }}</p>
              <p v-if="item.magicDefense">法术防御力 {{ item.magicDefense }}</p>
              <p v-if="item.critical">暴击率 {{ item.critical * 100 }}%</p>
              <p v-if="item.speed">行动速度 {{ item.speed }}</p>
              <p v-if="item.physique">根骨 {{ item.physique }}</p>
              <p v-if="item.dexterous">力道 {{ item.dexterous }}</p>
              <p v-if="item.spirit">灵力 {{ item.spirit }}</p>
              <p v-if="item.marketDec">物品描述： {{ item.marketDec }}</p>
            </div>
          </Poptip>
        </div>
      </div>
      <!-- 批量购买弹出框 -->
      <Modal
        width="620"
        title="批量购买"
        v-model="batchEject"
        @on-ok="bulkPurchase()"
        :styles="{ top: '100px' }"
      >
        <div>
          <Input v-model="batchNum" type="Number"  placeholder="请输入数量" />
        </div>
      </Modal>
    </Card>
<!--    <Button   size="small" style="margin-top:20px " @click="fanhui">返回</Button>
    <div id="left3">
      <Card style="font-family: Arial,Helvetica,Sans-Serif;">
        <p slot="title">商店</p>
        <div slot="extra"></div>
        <div>
          <div class="knapsack">
            <Poptip
              trigger="hover"
              v-for="item in shopList"
              :key="item.marketName"
              :title="item.marketName.toString()"
            >
              <p
                style="white-space: nowrap; height: 24px"
                :style="{ color: distinguishColor(item.color) }"
              >
                <Tag size="medium"  style="margin: 10px 0"> {{ item.marketName }} * {{ item.marketNum }}</Tag>
                &lt;!&ndash;            <span class="jjt_smail">{{ item.marketNum }}</span>&ndash;&gt;
                &lt;!&ndash;            <Tag type="dot" closable color="error"></Tag>&ndash;&gt;
                <Button
                  @click.prevent="purchaseItem(item)"
                  size="small"
                  type="info" ghost
                >购买
                </Button>
                <Button
                  @click.prevent="purchaseItem1(item)"
                  size="small"
                  type="info"
                >
                  批量购买
                </Button>
              </p>
              <div slot="content" >
                <p v-if="item.marketPrice">
                  商品价格 {{ item.marketPrice }}
                  {{ item.priceType == 0 ? "金币" : "灵石" }}
                </p>
                <p v-if="item.marketNum">购买次数 {{ item.marketNum }}</p>
                <p v-if="item.marketLevel">
                  商品最低购买等级 {{ item.marketLevel }}
                </p>
                <p v-if="item.typeDec">装备类型 {{ item.typeDec }}</p>
                <p v-if="item.level">装备等级 {{ item.level }}</p>
                <p v-if="item.itemNum">物品数量： {{ item.itemNum }}</p>
                <p v-if="item.life">生命值 {{ item.life }}</p>
                <p v-if="item.mana">真气值 {{ item.mana }}</p>
                <p v-if="item.attack">攻击力 {{ item.attack }}</p>
                <p v-if="item.magAttack">法术攻击力 {{ item.magAttack }}</p>
                <p v-if="item.defense">防御力 {{ item.defense }}</p>
                <p v-if="item.critical">暴击率 {{ item.critical * 100 }}%</p>
                <p v-if="item.speed">行动速度 {{ item.speed }}</p>
                <p v-if="item.physique">根骨 {{ item.physique }}</p>
                <p v-if="item.dexterous">力道 {{ item.dexterous }}</p>
                <p v-if="item.spirit">灵力 {{ item.spirit }}</p>
                <p v-if="item.marketDec">物品描述： {{ item.marketDec }}</p>
              </div>
            </Poptip>
          </div>
        </div>
        &lt;!&ndash; 批量购买弹出框 &ndash;&gt;
        <Modal
          width="620"
          title="批量购买"
          v-model="batchEject"
          @on-ok="bulkPurchase()"
          :styles="{ top: '100px' }"
        >
          <div>
            <Input v-model="batchNum" type="Number"  placeholder="请输入数量" />
          </div>
        </Modal>
      </Card>
    </div>-->
<!--    <div id="center3">
      <synthesis></synthesis>
    </div>-->
<!--    <div id="right3">
        <tradingBank ref="tradingBank"></tradingBank>
    </div>-->
  </div>
</template>

<script>
import Im from "./Im";
import synthesis from "./synthesis.vue";
import tradingBank from "./tradingBank.vue";


export default {
  name: "playersList",
  data() {
    return {
      shopList: [], // 商店列表
      batchNum: 1,
      isActive:false, // 切换主体
      batchEject: false,
      marketId: "",
    };
  },
  components: { Im,  synthesis,tradingBank },
  created() {
    this.waresList();
    const theme = window.localStorage.getItem("isTheme");
    if(theme === "black"){
      this.isActive=true;
    }else{
      this.isActive=false;
    }
  },
 /* props: ["chatPindao","chatUser","socketObj"],*/
  methods: {
    fanhui(){
      this.$router.back(-1);
    },
    // 返回品质颜色
    distinguishColor(color) {
      if (color == 1) {
        return "#000";
      } else if (color == 2) {
        return "#c5c52f";
      } else if (color == 3) {
        return "#049c04";
      } else if (color == 4) {
        return "#005aff";
      } else if (color == 5) {
        return "#ff00e0";
      } else if (color == 6) {
        return "#ff0000";
      } else if (color == 7) {
        return "#ff8c00";
      } else {
        return "#ff00c3e0";
      }
    },
    // 获取商店列表
    waresList() {
      this.$http
        .post("/gameMarket/waresList?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.shopList = res.data.data;
        });
    },
    // 商店购买
    purchaseItem(item) {
      this.$http
        .post(
          "/gameMarket/buyWares?charaId=" +
            this.getCookie("charaId") +
            "&waresId=" +
            item.marketId +
            "&waresNum=" +
            1
        )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});
          //send2(chatUser,text,pindao,fromt)
          Im.methods.send2(Im.data().chatUser, res.data.msg,Im.data().chatPindao,"系统消息",Im.data().socketObj);
          //let message = {from: "系统消息", to: Im.data().chatUser, text: res.data.msg, pindao: Im.data().chatPindao }
          //this.$Notice.warning(JSON.stringify(message));
          //Im.data().socketObj.send(JSON.stringify(message));
          this.waresList();
          //this.$bus.$emit("shopMsg", res.msg);
        })
        .catch((err) => {
          this.$Notice.warning({title:err.data.msg});
        });
    },
    // 打开批量购买的窗口
    purchaseItem1(item) {
      this.batchEject = true;
      this.marketId = item.marketId;
    },
    // 批量购买的确定
    bulkPurchase() {
      this.$http
        .post(
          "/gameMarket/buyWares?charaId=" +
            this.getCookie("charaId") +
            "&waresId=" +
            this.marketId +
            "&waresNum=" +
            this.batchNum
        )
        .then((res) => {
          this.$Notice.warning({title:res.data.msg});
          this.waresList();
          this.$bus.$emit("shopMsg1", "商店批量购买发送过来的");
        })
        .catch((err) => {
          this.$Notice.warning({title:err.data.msg});
        });
    },
  },
};
</script>



<style scoped>
#app3{
  width: 99%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  position: relative;
}
* {
  font-family:'思源黑体', sans-serif ;
}
#left3,
#center3,
#right3 {
  width: 32%;
  /* background-color: skyblue; */
}
/* knapsack 储物空间 和商店共用的 */
.knapsack {
  /* max-height: 516px; */
}
.knapsack /deep/ .ivu-poptip-popper {
  pointer-events: none;
}
.knapsack /deep/ .ivu-poptip {
  width: 50%;
}
.knapsack /deep/ .ivu-poptip p button {
  display: none;
  height: 22px;
}
.knapsack /deep/ .ivu-poptip p:hover {
  z-index: 9;
  position: relative;
}
.knapsack /deep/ .ivu-poptip p:hover button {
  display: inline-block;
}
.jjt_smail {
  color: #b50111;
  font-size: 12px;
}
.blackBackGroup{
  background-color: #151728;
  border: none;
  color: #9c9cab;
}
.blackBackGroup .ivu-card-head p, .ivu-card-head-inner{
  color: #4975d4;
}
.blackBackGroup span{
  background-color: #151728;
  color: #9c9cab;
}
.blackBackGroup2{

}
/* 为了给提示设置 颜色 */
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-inner {
  background-color: rgba(70, 76, 91, 0.9);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-arrow:after {
  border-top-color: rgba(70, 76, 91, 0.9);
}
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title {
  background: #373e57;
}
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-title-inner {
  background: #373e57;
  color: #fff;
}
.blackBackGroup /deep/ .ivu-poptip-popper .ivu-poptip-content .ivu-poptip-body {
  /* color: #fff;*/
  background: #373e57;
}
</style>



// WEBPACK FOOTER //
// src/components/shop.vue